// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RjJN","buttons":"styles_buttons__3knPZ"};